import React from "react";
import { Card, Col, Descriptions, Form, Input, InputNumber, Row, Select, Switch, Tag } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const PricingField = ({ mode }) => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const isViewMode = mode === "VIEW";

  if (isViewMode) {
    const pricing = form.getFieldValue(["pricing"]) || {};

    return (
      <Row gutter={16}>
        <Col span={24}>
          <Card>
            <Descriptions column={{ xs: 1, sm: 2, md: 3 }} bordered size="small">
              <Descriptions.Item label={t("countries.currency_symbol")}>
                {pricing.currencySymbol || "-"}
              </Descriptions.Item>
              <Descriptions.Item label={t("countries.tax_code")}>{pricing.taxCode || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.tax_percentage")}>
                {pricing.defaultTaxRate !== undefined ? `${pricing.defaultTaxRate}%` : "-"}
              </Descriptions.Item>
              <Descriptions.Item label={t("countries.delivery_tax_rate")}>
                {pricing.deliveryTaxRate !== undefined ? `${pricing.deliveryTaxRate}%` : "-"}
              </Descriptions.Item>
              <Descriptions.Item label={t("countries.tax_included")}>
                {pricing.taxIncludedPrices ? (
                  <Tag color="green" icon={<CheckOutlined />}>
                    {t("yes")}
                  </Tag>
                ) : (
                  <Tag icon={<CloseOutlined />}>{t("no")}</Tag>
                )}
              </Descriptions.Item>
              <Descriptions.Item label={t("countries.vat_rates")}>
                {pricing.vatRates && pricing.vatRates.length > 0
                  ? pricing.vatRates.map((rate) => `${rate}%`).join(", ")
                  : "-"}
              </Descriptions.Item>
              <Descriptions.Item label={t("countries.invoice_surcharge_percentage")}>
                {pricing.invoiceSurchargePercentage !== undefined ? `${pricing.invoiceSurchargePercentage}%` : "-"}
              </Descriptions.Item>
              <Descriptions.Item label={t("countries.default_credit_limit")}>
                {pricing.defaultCreditLimit !== undefined
                  ? `${pricing.currencySymbol || "€"}${pricing.defaultCreditLimit}`
                  : "-"}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card>
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name={["pricing", "currencySymbol"]} label={t("countries.currency_symbol")}>
                <Input placeholder="€" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name={["pricing", "taxCode"]} label={t("countries.tax_code")}>
                <Input placeholder="BTW" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={4}>
              <Form.Item name={["pricing", "defaultTaxRate"]} label={t("countries.tax_percentage")}>
                <InputNumber style={{ width: "100%" }} min={0} max={100} step={1} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={4}>
              <Form.Item name={["pricing", "deliveryTaxRate"]} label={t("countries.delivery_tax_rate")}>
                <InputNumber style={{ width: "100%" }} min={0} max={100} step={1} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                name={["pricing", "taxIncludedPrices"]}
                label={t("countries.tax_included")}
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                name={["pricing", "vatRates"]}
                label={t("countries.vat_rates")}
                normalize={(value) => {
                  if (!value) return [];
                  return value.map((v) => {
                    const num = Number(v);
                    return isNaN(num) ? v : num;
                  });
                }}
              >
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  tokenSeparators={[","]}
                  placeholder="0, 9, 21"
                  open={false}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                name={["pricing", "invoiceSurchargePercentage"]}
                label={t("countries.invoice_surcharge_percentage")}
              >
                <InputNumber style={{ width: "100%" }} min={0} max={100} step={1} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name={["pricing", "defaultCreditLimit"]} label={t("countries.default_credit_limit")}>
                <InputNumber style={{ width: "100%" }} min={0} step={50} />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default PricingField;
